
import { topics } from '../../content/topics'

export const setLessonsFormat = (appsHash: { [key: string]: any }, lessons: { [key: string]: any }[]) => {
   for ( let i = 0; i < lessons.length; i++ ) {
     const id = lessons[i].father_app;
     lessons[i].topic          = appsHash[id] && appsHash[id].topic      ? appsHash[id].topic      : '';
     lessons[i].top_topic      = appsHash[id] && appsHash[id].top_topic  ? appsHash[id].top_topic  : '';
     lessons[i].father_app_heb = appsHash[id] && appsHash[id].app        ? appsHash[id].app        : '';
     lessons[i].father_app_ar  = appsHash[id] && appsHash[id].app_arabic ? appsHash[id].app_arabic : '';
   }

   return lessons;
}


export const setPuzzlesFormat = (puzzles: { [key: string]: any }[]) => {
 
  for ( let i = 0; i < puzzles.length; i++ ) {

    const T_ = topics[`${ puzzles[i].topic }`];
    
    puzzles[i].top_topic = puzzles[i].top_topic ? puzzles[i].top_topic : T_ ? T_ : 'נושאים נוספים'
    
  }
 
  return puzzles;
}
